export default {"gitHash":"c318d5d1ff069766fde10a66e3605677eeabcff6","gitHashShort":"c318d5d","time":1694830467074,"platform":"linux","arch":"x64"};